interface WithName {
  firstName?: string | null;
  lastName?: string | null;
}
const getName = (person: WithName) =>
  [person.firstName, person.lastName].filter((name) => !!name).join(' ');

export default getName;
